<template>
    <layout v-slot="{ countDown }">
        <div class="p-3 p-xl-4">
            <!-- Info -->
            <div class="mb-2">
                <info-collapse-area>
                    <template v-slot:title>
                        <div class="w-100 d-flex flex-column flex-md-row justify-content-md-between">
                            <div class="mt-1 mt-md-0 mb-1 mb-md-0 fs-16">
                                {{ getObjectValue(application, 'name') }} {{ getObjectValue(application, 'surname') }}
                            </div>

                        </div>
                    </template>
                    <template v-slot:detail>
                        {{ getObjectValue(application, 'name') }}
                        {{ getObjectValue(application, 'surname') }}
                    </template>
                </info-collapse-area>
            </div>
            <div class="border rounded-sm pt-4 pl-4 pr-4">
                <SuccessRevision v-if="applicationStatus === 'approved'" type="accepted" />
                <SuccessRevision v-else-if="isRevisionSuccess" @close="isRevisionSuccess = false" />
                <template v-else-if="hasRejectedDocuments">
                    <b-alert show variant="danger" class="mb-4">
                        <h5 class="alert-heading"><i class="ri-error-warning-line mr-2"></i>{{ $t('revision_required') }}</h5>
                        <p class="mb-0">{{ $t('some_documents_rejected_info') }}</p>
                    </b-alert>
                    <DocumentsTab
                        :footer-info="footerInfo"
                        :isReadOnly="false"
                        :showOnlyRejected="true"
                        @success="onRevisionComplete"
                    />
                </template>
                <b-tabs v-else content-class="py-5 position-relative" class="line-tabs" fill v-model="tabIndex" no-nav-style>
                    <div class="tabs-bottom-line"></div>
                    <b-tab :disabled="0 > maxTabIndex" :active="tabIndex == 0">
                        <template #title>
                            {{ $t('personal_info') }}
                        </template>
                        <PersonalInfoTab
                            v-if="tabIndex===0"
                            :footer-info="footerInfo"
                            :isReadOnly="applicationStatus === 'waiting_approve'"
                            @success="goToNextTab(1)"
                        />
                    </b-tab>
                    <b-tab :disabled="1 > maxTabIndex" :active="tabIndex == 1">
                        <template #title>
                            {{ $t('education_info') }}
                        </template>
                        <EducationInfoTab
                            v-if="tabIndex===1"
                            :footer-info="footerInfo"
                            :isReadOnly="applicationStatus === 'waiting_approve'"
                            @success="goToNextTab(2)"
                        />
                    </b-tab>
                    <b-tab :disabled="2 > maxTabIndex" :active="tabIndex === 2">
                        <template #title>
                            {{ $t('reference') }}
                        </template>
                        <ReferenceTab
                            v-if="tabIndex===2"
                            :footer-info="footerInfo"
                            :isReadOnly="applicationStatus === 'waiting_approve'"
                            @success="goToNextTab(3)"
                        />
                    </b-tab>
                    <b-tab :disabled="3 > maxTabIndex" :active="tabIndex == 3">
                      <template #title>
                        {{ $t('your_documents') }}
                      </template>
                      <DocumentsTab
                          v-if="tabIndex===3"
                          :footer-info="footerInfo"
                          :isReadOnly="applicationStatus === 'waiting_approve'"
                          @success="onApplicationComplete"
                      />
                    </b-tab>
                    <b-tab :disabled="4 > maxTabIndex" :active="tabIndex == 4">
                        <template #title>{{$t('completed_status')}}</template>
                        <CompletedTab v-if="tabIndex===4" />
                    </b-tab>
                </b-tabs>

            </div>
        </div>
        <CommonModal ref="approveAppModal" size="md">
            <template v-slot:CommonModalContent>
                <div v-html="approveModalContent"></div>
                <div class="d-flex justify-content-center mt-4">
                    <b-button variant="primary" @click="approveAction">{{$t('i_approve')}}</b-button>
                </div>
            </template>
        </CommonModal>
        <CommonModal ref="progressModal" size="lg" :closeBtn="false" :onHideOnlyX="true">
            <template v-slot:CommonModalContent>
                <b-row>
                    <b-col cols="12">
                        <b-progress max="100" :value="progressValue" show-progress class="mb-3"></b-progress>
                    </b-col>
                    <b-col cols="12">
                        <b-alert show variant="info">{{$t('progress_bar_text',{min: progressTime})}}</b-alert>
                    </b-col>
                </b-row>
            </template>
        </CommonModal>
        <CommonModal ref="paymentModal" size="lg" :closeBtn="false" :onHideOnlyX="true">
          <template v-slot:CommonModalContent>
            <b-row>
              <b-col cols="12" v-if="paymentHtml">
                <iframe style="width: 100%; border: none; height: 38rem;" sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts"
                        :srcdoc="paymentHtml" frameborder="1" id="payment-frame"></iframe>
              </b-col>
              <b-col cols="12" class="d-flex justify-content-center mb-3" v-else>
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </b-col>
              <b-col cols="12" class="d-flex justify-content-center mb-3">
                <b-button variant="primary" @click="close3dModal">{{ $t('close') }}</b-button>
              </b-col>
            </b-row>
          </template>
        </CommonModal>
    </layout>
</template>
<script>
// Layouts
import Layout from '../layout/Layout'

// Component
import InfoCollapseArea from '@/components/elements/InfoCollapseArea'

// Tabs
import PersonalInfoTab from '../components/PersonalInfoTab'
import EducationInfoTab from '../components/EducationInfoTab'
import ReferenceTab from '../components/ReferenceTab'
import DocumentsTab from '../components/DocumentsTab'
import CompletedTab from '../components/CompletedTab'
import SuccessRevision from '../components/SuccessRevision.vue'

import CommonModal from '@/components/elements/CommonModal';

import qs from "qs";
import ConstantService from "@/services/ConstantService";
export default {
    name: "TransferPage",
    components: {
        Layout,
        InfoCollapseArea,
        CommonModal,
        PersonalInfoTab,
        EducationInfoTab,
        ReferenceTab,
        DocumentsTab,
        CompletedTab,
        SuccessRevision
    },
    metaInfo() {
        return {
            title: this.$t("bisep")+' '+this.$t('application_system'),
        };
    },
    computed: {
        applicationStatus() {
            let data = this.getWithExpiry('bisep_app_data', true)
            return data.status
        },
        hasRejectedDocuments() {
            if (!this.application || !this.application.documents) return false;
            // Eğer herhangi bir belge 'declined' durumundaysa true döner
            return Object.values(this.application.documents).some(status => status === 'declined');
        },
    },
    watch: {
        tabIndex: {
            handler(value){
                if (value>0){
                    this.setWithExpiry('tabIndex', value,3600000, true)
                }
            }
        }
    },
    data() {
        return {
            errorMessage:[],
            // Tab
            tabIndex: 0,
            maxTabIndex: 0,
            isRevisionSuccess: false,
            // Pin
            pin: null,

            // Data
            application: {},
            // Form
            formData: {},

            schoolMajorTypeOptions: [
                { value: null, text: '' },
                { value: this.$t('high_school_major_type_1'), text: this.$t('high_school_major_type_1') },
                { value: this.$t('high_school_major_type_2'), text: this.$t('high_school_major_type_2') },
                { value: this.$t('high_school_major_type_3'), text: this.$t('high_school_major_type_3') },
                { value: this.$t('high_school_major_type_4'), text: this.$t('high_school_major_type_4') },
                { value: this.$t('high_school_major_type_5'), text: this.$t('high_school_major_type_5') },
            ],
            constantAddress:null,

            approveModalContent: null,
            approveMode: null,
            approveApp: false,
            approveMultimedia: false,
            progressValue: 0,
            progressTime: null,
            estimateFields: [
                {
                    key: 'message',
                    label: this.$t('message'),
                },
                {
                    key: 'date',
                    label: this.$t('date'),
                },
            ],
            approveMultimediaValidate: false,
            approveAppValidate: false,
            branchOptions: [],
            secondBranchOptions: [],
            footerInfo: null,
            generalTabInfo: null,
            disabilityOptions: [
                { value: 'H', text: this.$t('none') },
                { value: 'E', text: this.$t('available') }
            ],
            noDataInfo: null,
            programDataInfo: true,
            paymentFormData: {},
            paymentHtml: '',
            paymentStatus: false,
            expiryMonthOptions: [
              { value: '01', text: '01' },
              { value: '02', text: '02' },
              { value: '03', text: '03' },
              { value: '04', text: '04' },
              { value: '05', text: '05' },
              { value: '06', text: '06' },
              { value: '07', text: '07' },
              { value: '08', text: '08' },
              { value: '09', text: '09' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
            ],
            letterAndSpaceMask: {
              mask: 'UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU',
              tokens: {
                'U': {
                  pattern: /[A-Za-z ÇĞİÖŞÜçğıöşü]/,
                  transform: function (v) {
                    v = v.replaceAll('i', 'İ');
                    return v.toUpper();
                  }
                }
              }
            },
            examData: '',
            highschoolClassOptions: [
                { value: '11', text: '11' },
                { value: '12', text: '12' },
                { value: 'M', text: this.$t('alumni') },
            ],
            referenceFields: [
                {
                    key: 'buttons',
                    label: ''
                },
                {
                    key: 'reference_full_name',
                    label: this.$t('name_surname'),
                },
                {
                    key: 'reference_post',
                    label: this.$t('mission'),
                },
                {
                    key: 'reference_tel',
                    label: this.$t('gsm_no'),
                },
                {
                    key: 'reference_email',
                    label: this.$t('email'),
                },
                {
                    key: 'letter_of_reference',
                    label: this.$t('letter_of_reference'),
                }
            ],
            referenceModalTitle: null,
            referenceFormData: {},

        }
    },
    created() {
        this.getFooterInfo()
        this.goToTab();
    },
    mounted() {
        this.$store.dispatch('bisepApplication/initData')
        this.$store.dispatch('bisepApplication/isLogin')
        let data = this.$store.getters['bisepApplication/getData']
        if (data) {
            this.application = data
            this.handleInitialTab(data.status)
        }
        // Pin
        this.pin = this.$store.getters['bisepApplication/getPin']
        this.formData = null
        this.setFormData();
    },
    methods: {
        close3dModal(){

        },
        approveAction(){
            this.approveMode == 'App' ? this.approveApp = true : this.approveMultimedia = true
            this.$refs.approveAppModal.$refs.commonModal.hide()
        },

        handleInitialTab(status) {
            const statusMap = {
                'waiting_personal_information': 0,
                'waiting_education_information': 1,
                'waiting_reference_information': 2,
                'waiting_documents': 3,
                'waiting_approve': 4
            };

            const targetTab = statusMap[status];

            if (typeof targetTab === 'number') {
                this.maxTabIndex = targetTab;
                this.$nextTick(() => {
                    this.tabIndex = targetTab;
                });
                this.setWithExpiry('tabIndex', targetTab, 3600000, true);
            }
        },

        goToTab() {
            const selectedTab = this.getWithExpiry('tabIndex', true)
            if (selectedTab && selectedTab>0){
                 this.goToNextTab(selectedTab);
            }
        },

        goToNextTab(nextIndex) {
            this.maxTabIndex = nextIndex
            this.setFormData()
            this.$nextTick(() => {
                this.tabIndex = nextIndex
            })
        },


        setFormData() {
            this.formData = this.getWithExpiry('bisep_app_data',true)
            if (this.formData && !this.formData.documents) {
                this.formData.documents = {}
            }
        },

        getFooterInfo() {
            const config = {
                params: {
                    'key': 'bisep_application.warning_message'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.footerInfo = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        onApplicationComplete() {
            this.maxTabIndex = 4
            this.$nextTick(() => {
                this.tabIndex = 4
            })
            this.setWithExpiry('tabIndex', 4, 3600000, true)
        },

        onRevisionComplete() {
            this.isRevisionSuccess = true;
            // Başvuruyu tekrar yükle ki statusler güncellensin
            this.$store.dispatch('bisepApplication/initData').then(() => {
                this.application = this.$store.getters['bisepApplication/getData'];
            });
        },
    }
}
</script>

<style scoped>
.font-size-16 { font-size: 16px; }
</style>
